import rules from "./rules";

const models = { rules };

export default models;
